import { useEffect, useState } from 'react';
import { personasResponseSchema, type Persona } from '@/shared/marketing-schemas';

type State = { data?: Persona[]; error?: Error; isLoading: boolean };

export function usePersonas(): State {
  const [state, setState] = useState<State>({ isLoading: true });
  useEffect(() => {
    let cancelled = false;
    void fetch('/api/marketing/personas')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .then((raw) => personasResponseSchema.parse(raw))
      .then((data) => {
        if (!cancelled) setState({ data, isLoading: false });
      })
      .catch((error: Error) => {
        if (!cancelled) setState({ error, isLoading: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return state;
}

type SingleState = { data?: Persona; error?: Error; isLoading: boolean };

export function usePersona(slug: string | undefined): SingleState {
  const all = usePersonas();
  if (all.isLoading) return { isLoading: true };
  if (all.error) return { error: all.error, isLoading: false };
  const data = all.data?.find((p) => p.slug === slug);
  return { data, isLoading: false };
}
